import WalletService from 'aurora-composition/services/walletService';
import * as types from './constants';

export const fetchWalletAndTransactions = (body, query) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_WALLET_AND_TRANSACTIONS, payload: { query } });
    const res = await Promise.all([
      new Promise(async (resolve, reject) => {
        try {
          const response = await WalletService.fetchWallet();
          resolve(response);
        } catch (error) {
          reject(error);
        }
      }),
      new Promise(async (resolve, reject) => {
        try {
          const response = await WalletService.fetchTransactions(body, query);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      }),
    ]);
    dispatch({
      type: types.FETCH_WALLET_AND_TRANSACTIONS_SUCCESS,
      payload: {
        wallet: res[0]?.data?.result || res[0]?.result,
        transactions: res[1]?.data?.result || res[1]?.result,
      },
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_WALLET_AND_TRANSACTIONS_ERROR,
      payload: { error },
    });
  }
};

export const fetchWallet = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_WALLET, payload: { query: null } });
    const res = await WalletService.fetchWallet();
    dispatch({
      type: types.FETCH_WALLET_SUCCESS,
      payload: { wallet: res?.data?.result || res?.result },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_WALLET_ERROR, payload: { error } });
  }
};

export const fetchTransactions = (body, query) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_TRANSACTIONS, payload: { query } });
    const res = await WalletService.fetchTransactions(body, query);
    const data = res?.data?.result ? res?.data?.result : res?.result;
    dispatch({
      type: types.FETCH_TRANSACTIONS_SUCCESS,
      payload: { transactions: data },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_TRANSACTIONS_ERROR, payload: { error } });
  }
};
